import React, { useEffect, useState } from "react";
import { Modal, } from "reactstrap";
import { toast } from 'react-toastify';
import userServices from "../../services/user.services";
import stateServices from "../../services/state.services";
import cityServices from "../../services/city.services";
import OperatorForm from "../../components/Operator/OperatorForm";
import OperatorList from "../../components/Operator/OperatorList";
import centerServices from "../../services/center.services";
const Index = () => {
    const [modal, setModal] = React.useState(false);
    const toggle = () => setModal(!modal);
    const [operators, setOperators] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [isAddMode, setIsAddMode] = useState('Add');
    const [centers, setCenters] = useState([]);
    const [loading, setLoading] = useState(true);
    const getAllOperators = () => {
        userServices.getAllUsers()
            .then((res) => {
                if (res.data.status === true) {
                    const rs = res.data.users.filter((item) => {
                        return item.user_type_id === 3;
                    })
                    setOperators(rs)
                }
                setLoading(false);
            }).catch((error) => {
                console.log('error', error)
                setLoading(false);
            })
    }
    const getAllCenter = async () => {
        const result = await centerServices.getAllCenter();
        if (result.data.status === true) {
            setCenters(result.data.centers)
        }
    }

    const deleteOperatorById = async (id) => {
        const result = await userServices.deleteUserById({ id: id });
        if (result.data.status === true) {
            toast.success('Record deleted successfully', { toastId: 'userDelete_success', autoClose: 3000 });
            getAllOperators();
        } else {
            toast.error(result.data.message, { toastId: 'userDelete_faild', autoClose: 3000 });
        }
    }

    const handleChangeStatus = async (id, status) => {
        const result = await userServices.updateUserById(id, { user_status: status })
        if (result.data.status === true) {
            getAllOperators()
            toast.success('Status updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    useEffect(() => {
        getAllOperators();
        getAllCenter();
        stateServices.getAllStates().then((res) => {
            if (res.data.status === true) {
                setStates(res.data.states)
            }
        });
        cityServices.getAllCity().then((res) => {
            if (res.data.status === true) {
                setCities(res.data.cities)
            }
        });
    }, [])


    const filterOperatorList = operators.map((operator) => {
        centers.map((center) => {
            if (operator.center_id === center._id) {
                operator.center_name = center.center_name
            }
        })
        return operator
    })

    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <>
                            {/*breadcrumb*/}
                            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                {/* <div className="breadcrumb-title pe-3">Operator</div> */}
                                <div className="ps-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item">
                                                <a href="#">
                                                    {/* <i className="bx bx-home-alt" /> */}
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Operator
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="ms-auto">
                                    <div className="btn-group">
                                        <button className="btn btn-primary"
                                            onClick={() => {
                                                toggle();
                                                setIsAddMode('Add')
                                            }}><i className="bx bx plus" />Add Operator</button>
                                        <Modal isOpen={modal} toggle={toggle} size="lg">
                                            <OperatorForm toggle={toggle} isAddMode={isAddMode} cities={cities} states={states} getAllOperators={getAllOperators} selectedRow={selectedRow} centers={centers} />
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                            {/*end breadcrumb*/}
                            <div className="card">
                                {/* <div className="card-header">
                                <div className="card-title">
                                    <h6 className="mb-0 pt-2 brand-color">Operator Mode</h6>
                                </div>    
                            </div> */}
                                <div className="card-body">
                                    <div className="card-title">
                                        {/* <h4 className="mb-0">Users</h4> */}
                                    </div>
                                    <OperatorList operators={filterOperatorList} loading={loading} setIsAddMode={setIsAddMode} setSelectedRow={setSelectedRow} setModal={setModal} deleteOperatorById={deleteOperatorById} getAllOperators={getAllOperators} handleChangeStatus={handleChangeStatus} />
                                </div>
                            </div>

                        </>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index;